<div class="google-search-page container">
  <mtn-google-search [map]="map" *ngIf="map" (selectEvent)="close()"></mtn-google-search>
</div>
